export const MapStyle =
  // [
  //   {
  //     "elementType": "geometry",
  //     "stylers": [
  //       {
  //         "color": "#F2F2F2"  // Ash for land areas (keeping it light)
  //       }
  //     ]
  //   },
  //   {
  //     "elementType": "labels.text.fill",
  //     "stylers": [
  //       {
  //         "color": "#716E80"  // Body color for labels
  //       }
  //     ]
  //   },
  //   {
  //     "elementType": "labels.text.stroke",
  //     "stylers": [
  //       {
  //         "color": "#FFFFFF"  // White text strokes for clarity
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "administrative",
  //     "elementType": "geometry.stroke",
  //     "stylers": [
  //       {
  //         "color": "#E0E0E0"  // Softer grey for boundaries
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "administrative.land_parcel",
  //     "elementType": "geometry.stroke",
  //     "stylers": [
  //       {
  //         "color": "#E0E0E0"  // Softer for land parcel boundaries
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "administrative.land_parcel",
  //     "elementType": "labels.text.fill",
  //     "stylers": [
  //       {
  //         "color": "#A0A0A0"  // A lighter, softer text for administrative areas
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "landscape.natural",
  //     "elementType": "geometry",
  //     "stylers": [
  //       {
  //         "color": "#ECECEC"  // Very soft natural landscapes
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "poi",
  //     "elementType": "geometry",
  //     "stylers": [
  //       {
  //         "color": "#D8D8D8"  // Soft grey for points of interest
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "poi",
  //     "elementType": "labels.text.fill",
  //     "stylers": [
  //       {
  //         "color": "#8B8B8B"  // Neutral grey for POI labels
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "poi.park",
  //     "elementType": "geometry.fill",
  //     "stylers": [
  //       {
  //         "color": "#E0E7FF"  // Light, subtle TBlue for parks (soft theme)
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "poi.park",
  //     "elementType": "labels.text.fill",
  //     "stylers": [
  //       {
  //         "color": "#64748B"  // Slightly softer blue-grey for park labels
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "road",
  //     "elementType": "geometry",
  //     "stylers": [
  //       {
  //         "color": "#FFFFFF"  // Pure white for roads for a clean look
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "road.arterial",
  //     "elementType": "geometry",
  //     "stylers": [
  //       {
  //         "color": "#D8B4FE"  // Light version of Primary for arterial roads
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "road.highway",
  //     "elementType": "geometry",
  //     "stylers": [
  //       {
  //         "color": "#9A48FF"  // Accent purple for highways, but not overwhelming
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "road.highway",
  //     "elementType": "geometry.stroke",
  //     "stylers": [
  //       {
  //         "color": "#D4D4D8"  // Soft grey strokes for highways
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "road.highway.controlled_access",
  //     "elementType": "geometry",
  //     "stylers": [
  //       {
  //         "color": "#C9A9FF"  // Soft, muted Primary for controlled access roads
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "road.highway.controlled_access",
  //     "elementType": "geometry.stroke",
  //     "stylers": [
  //       {
  //         "color": "#B399FF"  // Subtle Accent for controlled road strokes
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "road.local",
  //     "elementType": "labels.text.fill",
  //     "stylers": [
  //       {
  //         "color": "#939393"  // Medium grey for local road labels
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "transit.line",
  //     "elementType": "geometry",
  //     "stylers": [
  //       {
  //         "color": "#D4D4D8"  // Soft grey for transit lines
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "water",
  //     "elementType": "geometry.fill",
  //     "stylers": [
  //       {
  //         "color": "#3E358F"  // TBlue for water bodies, keeping it dark and subtle
  //       }
  //     ]
  //   },
  //   {
  //     "featureType": "water",
  //     "elementType": "labels.text.fill",
  //     "stylers": [
  //       {
  //         "color": "#FFFFFF"  // White text labels for water areas
  //       }
  //     ]
  //   }
  // ];

  // [
  //   {
  //       "elementType": "geometry",
  //       "stylers": [
  //           {
  //               "color": "#F2F2F2"  // Ash for land areas
  //           }
  //       ]
  //   },
  //   {
  //       "elementType": "labels.text.fill",
  //       "stylers": [
  //           {
  //               "color": "#716E80"  // Body color for text labels
  //           }
  //       ]
  //   },
  //   {
  //       "elementType": "labels.text.stroke",
  //       "stylers": [
  //           {
  //               "color": "#FFFFFF"  // White text strokes for clarity
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "administrative",
  //       "elementType": "geometry.stroke",
  //       "stylers": [
  //           {
  //               "color": "#D4D4D8"  // Grey for administrative boundaries
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "administrative.land_parcel",
  //       "elementType": "geometry.stroke",
  //       "stylers": [
  //           {
  //               "color": "#D4D4D8"  // Grey for land parcel boundaries
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "administrative.land_parcel",
  //       "elementType": "labels.text.fill",
  //       "stylers": [
  //           {
  //               "color": "#716E80"  // Body color for text labels in administrative areas
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "landscape.natural",
  //       "elementType": "geometry",
  //       "stylers": [
  //           {
  //               "color": "#F2F2F2"  // Ash for natural landscapes
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "poi",
  //       "elementType": "geometry",
  //       "stylers": [
  //           {
  //               "color": "#D4D4D8"  // Grey for points of interest
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "poi",
  //       "elementType": "labels.text.fill",
  //       "stylers": [
  //           {
  //               "color": "#716E80"  // Body text color for points of interest
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "poi.park",
  //       "elementType": "geometry.fill",
  //       "stylers": [
  //           {
  //               "color": "#3E358F"  // TBlue for parks
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "poi.park",
  //       "elementType": "labels.text.fill",
  //       "stylers": [
  //           {
  //               "color": "#716E80"  // Body text color for parks
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "road",
  //       "elementType": "geometry",
  //       "stylers": [
  //           {
  //               "color": "#FFFFFF"  // White for general roads
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "road.arterial",
  //       "elementType": "geometry",
  //       "stylers": [
  //           {
  //               "color": "#D8B4FE"  // Primary color for arterial roads
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "road.highway",
  //       "elementType": "geometry",
  //       "stylers": [
  //           {
  //               "color": "#9A48FF"  // Accent for highways
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "road.highway",
  //       "elementType": "geometry.stroke",
  //       "stylers": [
  //           {
  //               "color": "#D4D4D8"  // Grey for highway strokes
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "road.highway.controlled_access",
  //       "elementType": "geometry",
  //       "stylers": [
  //           {
  //               "color": "#D8B4FE"  // Primary color for controlled access roads
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "road.highway.controlled_access",
  //       "elementType": "geometry.stroke",
  //       "stylers": [
  //           {
  //               "color": "#9A48FF"  // Accent color for controlled access road strokes
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "road.local",
  //       "elementType": "labels.text.fill",
  //       "stylers": [
  //           {
  //               "color": "#716E80"  // Body text color for local roads
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "transit.line",
  //       "elementType": "geometry",
  //       "stylers": [
  //           {
  //               "color": "#D4D4D8"  // Grey for transit lines
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "water",
  //       "elementType": "geometry.fill",
  //       "stylers": [
  //           {
  //               "color": "#333271"  // GradientEnd (dark blue) for water
  //           }
  //       ]
  //   },
  //   {
  //       "featureType": "water",
  //       "elementType": "labels.text.fill",
  //       "stylers": [
  //           {
  //               "color": "#FFFFFF"  // White text for water labels
  //           }
  //       ]
  //   }
  // ];

  [
    {
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [
        {
          saturation: 36,
        },
        {
          color: "#333333",
        },
        {
          lightness: 40,
        },
      ],
    },
    {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#ffffff",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: "all",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#fefefe",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#fefefe",
        },
        {
          lightness: 17,
        },
        {
          weight: 1.2,
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#d5d5d5",
        },
      ],
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#7574c0",
        },
        {
          saturation: "-37",
        },
        {
          lightness: "75",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      featureType: "poi.business",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#7574c0",
        },
        {
          saturation: "-2",
        },
        {
          lightness: "53",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#f9ebff",
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#7574c0",
        },
        {
          lightness: "69",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#7574c0",
        },
        {
          lightness: "25",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 29,
        },
        {
          weight: 0.2,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [
        {
          lightness: "38",
        },
        {
          color: "#000000",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 18,
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [
        {
          color: "#f2f2f2",
        },
        {
          lightness: 19,
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#333271",
        },
        {
          lightness: 17,
        },
      ],
    },
  ];

export const PickupLocationIcon =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(`
  <svg width="26" height="46" viewBox="0 0 56 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_5310_1027)">
        <rect x="14.915" y="52.3828" width="25.8372" height="9.93737" rx="4.17369" fill="#B3B3B3" fill-opacity="0.8"/>
    </g>
    <g filter="url(#filter1_d_5310_1027)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M28.0558 52.3822C29.9941 52.3822 39.2243 40.7906 41.5003 37.0982C44.9989 31.4223 47.1589 28.0644 47.1589 21.7985C47.1589 11.2481 38.6062 2.69531 28.0558 2.69531C17.5054 2.69531 8.95264 11.2481 8.95264 21.7985C8.95264 28.097 10.9541 31.4325 14.4411 37.0982C16.8714 41.0471 26.1175 52.3822 28.0558 52.3822Z" fill="#9A48FF"/>
        <path d="M28.0558 53.5746C28.4442 53.5746 28.7876 53.439 29.027 53.3214C29.2868 53.1937 29.5484 53.0242 29.8015 52.8387C30.3088 52.467 30.8827 51.956 31.4867 51.367C32.7001 50.1837 34.135 48.5862 35.5628 46.8938C38.4101 43.519 41.3312 39.6452 42.5154 37.724C42.6087 37.5726 42.7012 37.4227 42.7928 37.2742C46.1273 31.8693 48.3514 28.2642 48.3514 21.7985C48.3514 10.5895 39.2648 1.50283 28.0558 1.50283C16.8468 1.50283 7.76015 10.5895 7.76015 21.7985C7.76015 28.4601 9.93206 32.047 13.4255 37.7233C14.6899 39.7777 17.6569 43.6545 20.5283 46.998C21.9686 48.675 23.4109 50.2486 24.629 51.4118C25.2353 51.9908 25.8109 52.4921 26.3191 52.8565C26.5728 53.0384 26.8345 53.2042 27.0937 53.3287C27.3333 53.4439 27.6732 53.5746 28.0558 53.5746Z" stroke="white" stroke-width="2.38497"/>
    </g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M28.0558 31.3512C33.331 31.3512 37.6074 27.0748 37.6074 21.7996C37.6074 16.5244 33.331 12.248 28.0558 12.248C22.7807 12.248 18.5043 16.5244 18.5043 21.7996C18.5043 27.0748 22.7807 31.3512 28.0558 31.3512Z" fill="white"/>
    <defs>
        <filter id="filter0_f_5310_1027" x="1.94901" y="39.4168" width="51.7692" height="35.8696" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="6.48302" result="effect1_foregroundBlur_5310_1027"/>
        </filter>
        <filter id="filter1_d_5310_1027" x="0.605206" y="0.310547" width="54.9012" height="66.3819" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="5.96242"/>
            <feGaussianBlur stdDeviation="2.98121"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5310_1027"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5310_1027" result="shape"/>
        </filter>
    </defs>
</svg>
                              `);

export const DropoffLocationIcon =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(`
<svg width="26" height="46" viewBox="0 0 56 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_5310_1027)">
        <rect x="14.915" y="52.3828" width="25.8372" height="9.93737" rx="4.17369" fill="#B3B3B3" fill-opacity="0.8"/>
    </g>
    <g filter="url(#filter1_d_5310_1027)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M28.0558 52.3822C29.9941 52.3822 39.2243 40.7906 41.5003 37.0982C44.9989 31.4223 47.1589 28.0644 47.1589 21.7985C47.1589 11.2481 38.6062 2.69531 28.0558 2.69531C17.5054 2.69531 8.95264 11.2481 8.95264 21.7985C8.95264 28.097 10.9541 31.4325 14.4411 37.0982C16.8714 41.0471 26.1175 52.3822 28.0558 52.3822Z" fill="#FF0000"/>
        <path d="M28.0558 53.5746C28.4442 53.5746 28.7876 53.439 29.027 53.3214C29.2868 53.1937 29.5484 53.0242 29.8015 52.8387C30.3088 52.467 30.8827 51.956 31.4867 51.367C32.7001 50.1837 34.135 48.5862 35.5628 46.8938C38.4101 43.519 41.3312 39.6452 42.5154 37.724C42.6087 37.5726 42.7012 37.4227 42.7928 37.2742C46.1273 31.8693 48.3514 28.2642 48.3514 21.7985C48.3514 10.5895 39.2648 1.50283 28.0558 1.50283C16.8468 1.50283 7.76015 10.5895 7.76015 21.7985C7.76015 28.4601 9.93206 32.047 13.4255 37.7233C14.6899 39.7777 17.6569 43.6545 20.5283 46.998C21.9686 48.675 23.4109 50.2486 24.629 51.4118C25.2353 51.9908 25.8109 52.4921 26.3191 52.8565C26.5728 53.0384 26.8345 53.2042 27.0937 53.3287C27.3333 53.4439 27.6732 53.5746 28.0558 53.5746Z" stroke="white" stroke-width="2.38497"/>
    </g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M28.0558 31.3512C33.331 31.3512 37.6074 27.0748 37.6074 21.7996C37.6074 16.5244 33.331 12.248 28.0558 12.248C22.7807 12.248 18.5043 16.5244 18.5043 21.7996C18.5043 27.0748 22.7807 31.3512 28.0558 31.3512Z" fill="white"/>
    <defs>
        <filter id="filter0_f_5310_1027" x="1.94901" y="39.4168" width="51.7692" height="35.8696" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="6.48302" result="effect1_foregroundBlur_5310_1027"/>
        </filter>
        <filter id="filter1_d_5310_1027" x="0.605206" y="0.310547" width="54.9012" height="66.3819" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="5.96242"/>
            <feGaussianBlur stdDeviation="2.98121"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5310_1027"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5310_1027" result="shape"/>
        </filter>
    </defs>
</svg>
                                `);

export const WalkerLocationIcon =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(`
  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="person-walking" class="svg-inline--fa fa-person-walking text-5xl mb-4" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#9A48FF" d="M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"></path></svg>
`);

export const PartnerLocationIcon =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(`
<svg width="40" height="42" viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.6973 25.5934C16.9896 23.5526 20.0267 23.5333 22.8136 25.526C24.45 27.4369 26.6016 28.4043 29.2585 28.4332C29.6868 28.438 30.1297 28.4188 30.5821 28.3754C31.3378 28.3177 31.641 28.9049 31.4918 30.1419C31.4581 30.4307 31.3955 30.7532 31.3137 31.1093C30.3751 36.2836 27.3813 39.1426 22.3226 39.6769C22.3611 40.0812 22.4237 40.447 22.5199 40.7791C23.5596 41.3326 24.5271 41.607 25.4223 41.607C26.5101 41.607 27.4872 41.1979 28.3632 40.3748C30.8853 37.6265 32.5988 34.6904 33.4893 31.5618C35.4675 24.6452 33.0368 12.8143 23.1601 17.0596C22.1878 17.6853 21.283 18.0029 20.4358 18.0126C20.2722 18.0126 20.1085 18.0029 19.9497 17.9837C19.7909 18.0029 19.6272 18.0174 19.4636 18.0126C18.6164 18.0078 17.7067 17.6901 16.7393 17.0596C6.85291 12.8143 4.42705 24.6452 6.40047 31.5618C7.29573 34.6904 9.00442 37.6265 11.5265 40.3748C12.3977 41.193 13.3796 41.607 14.4674 41.607C15.5648 41.607 16.7682 41.1931 18.087 40.3604L18.1014 40.3507C18.4817 40.1967 18.8571 40.0908 19.2373 40.0331C19.3577 39.7683 19.4636 39.4892 19.5598 39.1956C20.1133 36.8997 19.7331 35.0947 18.4143 33.7807C16.8067 32.5629 15.8729 31.2441 15.6178 29.8338C15.459 31.1238 15.8921 32.3223 16.927 33.4245C19.2614 36.9526 19.0111 39.2822 16.1713 40.4181C12.6143 41.1449 10.4147 39.1522 9.58682 34.4449C9.2162 30.8302 10.588 27.8749 13.6973 25.5934Z" fill="#333271"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.4046 28.9628C21.7788 28.9868 21.2927 29.5163 21.3168 30.142C21.3408 30.7677 21.8703 31.2539 22.496 31.2298C23.1217 31.2057 23.6127 30.6763 23.5838 30.0506C23.5549 29.4248 23.0303 28.9387 22.4046 28.9628Z" fill="#333271"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M28.1805 0.444445C30.2213 1.79696 30.5726 5.82081 28.965 9.43554C27.3574 13.0503 24.3973 14.8841 22.3565 13.5364C20.3156 12.1839 19.9643 8.16004 21.5719 4.54531C23.1795 0.930581 26.1396 -0.90807 28.1805 0.444445Z" fill="#333271"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M39.5541 8.31403C40.5793 10.48 39.1786 13.8011 36.4255 15.7264C33.6723 17.6565 30.6111 17.464 29.5859 15.298C28.5607 13.1321 29.9613 9.81094 32.7145 7.88565C35.4676 5.96036 38.5288 6.15289 39.5541 8.31403Z" fill="#333271"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.7095 0.747669C9.66868 2.10018 9.31731 6.12404 10.9249 9.73877C12.5325 13.3535 15.4927 15.1873 17.5335 13.8348C19.5743 12.4823 19.9257 8.45845 18.318 4.84372C16.7104 1.22899 13.7503 -0.604846 11.7095 0.747669Z" fill="#333271"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.335869 8.61743C-0.689347 10.7834 0.7113 14.1045 3.46446 16.0298C6.21763 17.9647 9.27884 17.7722 10.3041 15.6062C11.3293 13.4403 9.92862 10.1192 7.17546 8.19387C4.4223 6.26377 1.36109 6.45148 0.335869 8.61743Z" fill="#333271"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M30.611 28.7895C30.38 28.8136 30.149 28.828 29.9276 28.8377H29.8987C30.0816 29.1842 30.2741 29.4393 30.4859 29.603C30.6736 29.7473 30.8758 29.8099 31.102 29.7955C31.1261 29.4152 31.0924 29.1361 31.0057 28.9628C30.9383 28.8328 30.8084 28.7751 30.611 28.7895Z" fill="#333271"/>
</svg>
`);

export const PartnerPinLocationIcon =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(`
<svg width="26" height="46" viewBox="0 0 56 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_5310_1027)">
        <rect x="14.915" y="52.3828" width="25.8372" height="9.93737" rx="4.17369" fill="#B3B3B3" fill-opacity="0.8"/>
    </g>
    <g filter="url(#filter1_d_5310_1027)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M28.0558 52.3822C29.9941 52.3822 39.2243 40.7906 41.5003 37.0982C44.9989 31.4223 47.1589 28.0644 47.1589 21.7985C47.1589 11.2481 38.6062 2.69531 28.0558 2.69531C17.5054 2.69531 8.95264 11.2481 8.95264 21.7985C8.95264 28.097 10.9541 31.4325 14.4411 37.0982C16.8714 41.0471 26.1175 52.3822 28.0558 52.3822Z" fill="#3E358F"/>
        <path d="M28.0558 53.5746C28.4442 53.5746 28.7876 53.439 29.027 53.3214C29.2868 53.1937 29.5484 53.0242 29.8015 52.8387C30.3088 52.467 30.8827 51.956 31.4867 51.367C32.7001 50.1837 34.135 48.5862 35.5628 46.8938C38.4101 43.519 41.3312 39.6452 42.5154 37.724C42.6087 37.5726 42.7012 37.4227 42.7928 37.2742C46.1273 31.8693 48.3514 28.2642 48.3514 21.7985C48.3514 10.5895 39.2648 1.50283 28.0558 1.50283C16.8468 1.50283 7.76015 10.5895 7.76015 21.7985C7.76015 28.4601 9.93206 32.047 13.4255 37.7233C14.6899 39.7777 17.6569 43.6545 20.5283 46.998C21.9686 48.675 23.4109 50.2486 24.629 51.4118C25.2353 51.9908 25.8109 52.4921 26.3191 52.8565C26.5728 53.0384 26.8345 53.2042 27.0937 53.3287C27.3333 53.4439 27.6732 53.5746 28.0558 53.5746Z" stroke="white" stroke-width="2.38497"/>
    </g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M28.0558 31.3512C33.331 31.3512 37.6074 27.0748 37.6074 21.7996C37.6074 16.5244 33.331 12.248 28.0558 12.248C22.7807 12.248 18.5043 16.5244 18.5043 21.7996C18.5043 27.0748 22.7807 31.3512 28.0558 31.3512Z" fill="white"/>
    <defs>
        <filter id="filter0_f_5310_1027" x="1.94901" y="39.4168" width="51.7692" height="35.8696" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="6.48302" result="effect1_foregroundBlur_5310_1027"/>
        </filter>
        <filter id="filter1_d_5310_1027" x="0.605206" y="0.310547" width="54.9012" height="66.3819" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="5.96242"/>
            <feGaussianBlur stdDeviation="2.98121"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5310_1027"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5310_1027" result="shape"/>
        </filter>
    </defs>
</svg>
                                `);

export const WalkInProgressIcon =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(`
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512">
<path d="M0 0 C15.44856854 12.43757365 25.07045096 31.5003874 33.171875 49.21875 C33.58878349 50.12884575 33.58878349 50.12884575 34.01411438 51.05732727 C35.40832656 54.10460504 36.78835071 57.15637033 38.14770508 60.21948242 C45.59634261 76.67668763 54.43064203 89.74236178 71.43359375 96.8828125 C85.0904223 102.15977946 85.0904223 102.15977946 99.06640625 100.46875 C111.20016664 99.53195232 121.56790224 107.52736831 130.32421875 115.02734375 C131.22914063 115.83300781 132.1340625 116.63867188 133.06640625 117.46875 C134.03320312 118.32597656 135 119.18320313 135.99609375 120.06640625 C145.30955836 128.42577163 154.37400801 137.14232591 162.4921875 146.67578125 C164.62197838 149.10152322 166.91978207 151.33432448 169.22290039 153.59399414 C171.00604489 155.40736544 172.6737651 157.27552576 174.33203125 159.203125 C177.89691599 163.30311929 181.58430043 167.27122682 185.31640625 171.21875 C190.67515009 176.90981904 195.98670504 182.63778448 201.2578125 188.41015625 C204.50196964 191.95337865 207.78464722 195.46038806 211.06640625 198.96875 C216.18634507 204.44336459 221.27297173 209.94601206 226.328125 215.48046875 C228.30050192 217.63773343 230.28403074 219.78421192 232.2734375 221.92578125 C232.81210449 222.50634277 233.35077148 223.0869043 233.90576172 223.68505859 C234.93854492 224.79735948 235.97263524 225.90844877 237.00830078 227.01806641 C239.83695671 230.06706178 242.51053264 233.18780586 245.06640625 236.46875 C243.96490204 239.77326262 242.25412613 241.19475792 239.4765625 243.11328125 C238.83984619 243.55647705 238.20312988 243.99967285 237.54711914 244.45629883 C237.05848389 244.79040771 236.56984863 245.1245166 236.06640625 245.46875 C173.06640625 177.21875 173.06640625 177.21875 171.56713867 175.59448242 C170.56477834 174.50863283 169.56233663 173.42285837 168.55981445 172.3371582 C166.09526237 169.66792637 163.63203015 166.99750409 161.171875 164.32421875 C158.68599539 161.62359257 156.19400992 158.92868643 153.69970703 156.23583984 C152.56572961 155.00897459 151.43405448 153.77997893 150.30419922 152.54931641 C132.21768529 132.07249607 132.21768529 132.07249607 110.06640625 116.46875 C110.39640625 117.45875 110.72640625 118.44875 111.06640625 119.46875 C111.5311387 126.32355363 110.99464816 132.11182403 106.33203125 137.45703125 C102.1633049 141.35915301 98.67262916 143.4175832 93.06640625 144.46875 C92.73640625 147.43875 92.40640625 150.40875 92.06640625 153.46875 C88.10640625 153.46875 84.14640625 153.46875 80.06640625 153.46875 C80.06640625 149.83875 80.06640625 146.20875 80.06640625 142.46875 C78.90109375 142.34628906 77.73578125 142.22382813 76.53515625 142.09765625 C57.98987953 139.75505209 41.0802289 130.4351631 27.06640625 118.46875 C26.41542969 117.91960937 25.76445312 117.37046875 25.09375 116.8046875 C20.93855183 112.97365372 17.629783 108.41632106 14.25390625 103.90625 C13.53243408 102.94972534 13.53243408 102.94972534 12.79638672 101.97387695 C10.08803909 98.26156458 8.26716981 94.97334856 7.06640625 90.46875 C6.40640625 90.46875 5.74640625 90.46875 5.06640625 90.46875 C5.02499008 91.04216125 4.98357391 91.61557251 4.94090271 92.20635986 C4.33366982 99.37063367 2.96848404 106.25278535 1.4140625 113.265625 C1.15386826 114.45802795 0.89367401 115.65043091 0.62559509 116.87896729 C0.07771731 119.38393242 -0.47290006 121.88829978 -1.02612305 124.39208984 C-1.87127273 128.21956053 -2.70680397 132.04903835 -3.54101562 135.87890625 C-4.07625755 138.32043651 -4.61204598 140.76184704 -5.1484375 143.203125 C-5.39746323 144.3438446 -5.64648895 145.48456421 -5.90306091 146.65985107 C-7.75215491 155.00025125 -7.75215491 155.00025125 -9.26977539 158.91894531 C-10.19786234 161.49177822 -10.19786234 161.49177822 -9.00585938 164.00390625 C-8.45607422 164.83792969 -7.90628906 165.67195312 -7.33984375 166.53125 C-6.72858643 167.48169189 -6.1173291 168.43213379 -5.48754883 169.41137695 C-4.80974365 170.42031006 -4.13193848 171.42924316 -3.43359375 172.46875 C-2.74740967 173.52602295 -2.06122559 174.5832959 -1.35424805 175.67260742 C0.07311768 177.87073426 1.50853738 180.0636506 2.95166016 182.25146484 C6.11090435 187.05780518 9.17894979 191.92075087 12.25390625 196.78125 C15.63742779 202.10654386 19.03308066 207.42302059 22.46875 212.71484375 C23.01184814 213.55813232 23.55494629 214.4014209 24.11450195 215.27026367 C25.12297985 216.83614459 26.13784631 218.39794117 27.16088867 219.9543457 C32.33969028 228.02947055 35.32960462 236.71551054 37.79956055 245.93823242 C38.04237762 246.82577713 38.2851947 247.71332184 38.53536987 248.62776184 C39.32633523 251.52501702 40.1087181 254.42450699 40.890625 257.32421875 C41.4426178 259.35592864 41.99501821 261.38752782 42.54780579 263.41902161 C43.70044318 267.66008875 44.8489633 271.90224213 45.99438477 276.14526367 C47.46015619 281.57410336 48.93498596 287.0004314 50.41273785 292.42602062 C51.55262139 296.61422688 52.68833397 300.80355511 53.82273293 304.99324989 C54.36501535 306.99456848 54.90843821 308.99557841 55.45303917 310.99626732 C56.21331279 313.79222821 56.96810446 316.58961291 57.72143555 319.38745117 C57.94532455 320.20684174 58.16921356 321.0262323 58.39988708 321.87045288 C60.92114203 331.28804899 62.24616127 339.90670779 57.83984375 349 C53.9383659 355.25905538 49.59018859 359.07253436 42.75390625 361.78125 C34.15664152 363.38412987 26.72161904 363.04183129 19.06640625 358.46875 C13.33374548 354.08140717 10.6986612 349.15460182 8.64306641 342.30615234 C8.43338037 341.61063955 8.22369434 340.91512676 8.00765419 340.19853783 C5.7556696 332.62396255 3.7683493 324.97844753 1.79966354 317.32637405 C0.6639356 312.92946828 -0.49827545 308.53952625 -1.65625 304.1484375 C-3.1131581 298.62120317 -4.56223299 293.09236283 -5.97900391 287.5546875 C-12.39239791 260.34037497 -12.39239791 260.34037497 -25.71386719 236.09222412 C-27.62956007 233.54240852 -29.26095381 230.82474191 -30.9296875 228.109375 C-32.07512105 226.31141465 -33.22218925 224.51449438 -34.37109375 222.71875 C-35.24797852 221.34203125 -35.24797852 221.34203125 -36.14257812 219.9375 C-39.02735944 215.41594016 -41.95046912 210.92632033 -44.93359375 206.46875 C-45.00352539 207.73356201 -45.07345703 208.99837402 -45.14550781 210.30151367 C-45.41256606 215.05320538 -45.70105729 219.80340657 -45.99560547 224.5534668 C-46.1195003 226.59837504 -46.23779917 228.64363114 -46.35009766 230.68920898 C-46.51377179 233.65200049 -46.6984259 236.61290135 -46.88671875 239.57421875 C-46.93169495 240.46956833 -46.97667114 241.36491791 -47.02301025 242.28739929 C-47.83253269 254.20711929 -52.44558965 265.19194023 -56.75 276.22265625 C-57.20656479 277.40302963 -57.66312958 278.58340302 -58.13352966 279.79954529 C-59.34094251 282.91841801 -60.55222666 286.03572773 -61.76544189 289.15234375 C-62.96113683 292.22713055 -64.15109214 295.3041374 -65.34179688 298.38085938 C-67.2369075 303.27547367 -69.14120001 308.1663814 -71.05126953 313.05517578 C-72.77372712 317.46829127 -74.47685877 321.88737268 -76.1517458 326.31873798 C-76.8822282 328.24815427 -77.61813976 330.17540758 -78.35594177 332.10203552 C-79.27297348 334.49994853 -80.18057684 336.90149765 -81.07679749 339.30726624 C-84.68063707 348.66787218 -89.02575648 356.7187812 -98.12109375 361.65625 C-106.12025074 363.96711757 -113.50352074 364.15850684 -121.03125 360.4296875 C-127.14230087 356.88870475 -131.90270188 352.33492215 -134.4140625 345.53515625 C-136.49229027 337.26912249 -134.7887615 330.268243 -131.94921875 322.46875 C-131.48465775 321.16874809 -131.48465775 321.16874809 -131.01071167 319.84248352 C-127.23265132 309.36807847 -123.14871469 299.01170045 -119.05859375 288.65625 C-118.2991326 286.72604778 -117.54001742 284.7957094 -116.78125 282.86523438 C-116.40523148 281.91126266 -116.02921295 280.95729095 -115.64179993 279.97441101 C-114.87943923 278.03135374 -114.12329733 276.08584569 -113.37321472 274.13801575 C-111.54739628 269.42172954 -109.64980058 264.79777007 -107.46606445 260.23510742 C-99.49872643 243.01132906 -98.89399442 225.59734846 -97.99780273 206.93560791 C-97.7846813 202.68128934 -97.52546244 198.42977305 -97.27148438 194.17773438 C-96.90803001 187.97890646 -96.56008149 181.77961144 -96.24975586 175.57788086 C-96.18807724 174.34597519 -96.12639862 173.11406952 -96.06285095 171.84483337 C-95.68323702 164.42396709 -95.68323702 164.42396709 -98.30859375 157.65625 C-105.7546981 143.44095988 -101.87679827 128.95164664 -98.5546875 113.9921875 C-98.21896712 112.44872094 -97.88410879 110.90506666 -97.55006409 109.36123657 C-96.67795738 105.33972279 -95.7961083 101.32041549 -94.91149902 97.30163574 C-93.49005731 90.83659646 -92.08314633 84.36838501 -90.67738533 77.89992142 C-90.18651029 75.64848083 -89.6910602 73.39808448 -89.19493103 71.14779663 C-88.8947384 69.77482427 -88.5946483 68.40182949 -88.29467773 67.02880859 C-88.03122055 65.83113861 -87.76776337 64.63346863 -87.49632263 63.39950562 C-86.83931191 60.47510134 -86.83931191 60.47510134 -86.93359375 57.46875 C-101.7328224 72.33617786 -112.38248584 90.48745815 -122.93359375 108.46875 C-127.46667876 116.19383118 -131.54676284 122.99978583 -139.93359375 126.84375 C-147.2776296 128.37375747 -153.36603724 127.36976562 -159.66796875 123.3671875 C-163.37248697 120.52461164 -165.51188532 117.8918429 -166.93359375 113.46875 C-168.55369296 100.00392548 -162.67483633 91.32066704 -155.74609375 80.28125 C-155.17511963 79.36706299 -154.60414551 78.45287598 -154.01586914 77.51098633 C-142.42425703 59.02890383 -130.37379417 40.99515187 -114.93359375 25.46875 C-114.4545459 24.98567383 -113.97549805 24.50259766 -113.48193359 24.00488281 C-86.11759927 -3.20202556 -34.53548442 -25.78931749 0 0 Z " fill="#7C3AED" transform="translate(166.93359375,130.53125)"/>
<path d="M0 0 C4.41235316 2.24264231 8.16595212 5.06300166 11.45654297 8.75976562 C16.81473234 14.4811525 21.75908149 17.23560638 29.68457031 17.72924805 C36.39900725 17.83677049 43.1042769 17.60726089 49.81265259 17.340271 C93.8084731 15.6627056 93.8084731 15.6627056 111.84375 31.75830078 C114.71802343 33.79972858 116.57727344 34.6101137 119.859375 35.64404297 C125.6564579 37.69050499 130.46368334 39.77737253 134 45 C137.17309139 56.47001677 136.00250761 68.93103783 135.47949219 80.69458008 C135.33998429 84.27321838 135.28328335 87.85094922 135.23082542 91.43176842 C135.12074353 98.83288598 134.9581636 106.23502673 134.64208984 113.63037109 C134.59144379 114.93622162 134.54079773 116.24207214 134.48861694 117.5874939 C133.89047165 121.76494722 132.68585486 124.68877956 129.3125 127.3125 C125.84767407 128.34258338 122.54883321 128.5914722 119 128 C116.1899654 126.20636089 114.49059532 124.98119065 113 122 C112.91302446 119.08323302 112.8844067 116.18997412 112.90234375 113.2734375 C112.90335083 112.50878174 112.90435791 111.74412598 112.90539551 110.95629883 C112.91063339 108.09585066 112.92459463 105.23542385 112.9375 102.375 C112.958125 95.98125 112.97875 89.5875 113 83 C92.54 83 72.08 83 51 83 C55.95 91.91 60.9 100.82 66 110 C68.15019919 114.30039837 68.41332248 116.28812373 68 121 C66.34860695 124.5386994 65.28394771 125.81070153 62 128 C59.9140625 128.37109375 59.9140625 128.37109375 57.625 128.4375 C56.87476563 128.47746094 56.12453125 128.51742187 55.3515625 128.55859375 C50.94885185 127.51276713 48.85187047 124.29878705 46.48339844 120.68774414 C44.79907575 117.91958082 43.17277202 115.12435512 41.5625 112.3125 C40.45994832 110.4125788 39.35708537 108.5128382 38.25390625 106.61328125 C37.71910645 105.68725098 37.18430664 104.7612207 36.63330078 103.80712891 C34.13370428 99.51111088 31.57095501 95.25359313 29 91 C28.73896484 91.50225098 28.47792969 92.00450195 28.20898438 92.52197266 C23.77799808 101.03280317 19.34038936 109.54535458 14.6875 117.9375 C14.09324219 119.01902344 13.49898438 120.10054688 12.88671875 121.21484375 C10.52181953 124.70588546 8.13055665 127.45122026 3.9375 128.53125 C0.4134285 128.47441014 -1.69326047 128.16003801 -4.875 126.5 C-7.75518801 123.11154351 -8.84158172 120.44092921 -9 116 C-7.46282898 110.74307008 -4.48456332 106.1150411 -1.546875 101.54296875 C10.50100797 81.98449397 13.75780907 59.83454559 9.57043457 37.13165283 C7.91081939 30.92984883 3.81564645 27.35245484 -1.51000977 24.17822266 C-2.9882701 23.41782995 -4.48397527 22.69008369 -5.99755859 22.00268555 C-8.95315333 20.52272608 -10.90917222 18.52523277 -13 16 C-14.18482882 11.92715094 -14.26442204 9.76388589 -12.875 5.75 C-9.54160234 0.86101677 -5.89196104 -1.01976249 0 0 Z " fill="#9A48FF" transform="translate(326,365)"/>
<path d="M0 0 C9.56918391 8.85149512 15.64414228 21.22837827 16.78125 34.19140625 C16.84570312 34.88234375 16.91015625 35.57328125 16.9765625 36.28515625 C17.57465097 48.24692558 13.93287284 60.62718776 6.78125 70.19140625 C6.25660156 70.89652344 5.73195313 71.60164063 5.19140625 72.328125 C-2.706783 82.08471172 -14.70421313 89.38518443 -27.21875 91.19140625 C-44.35274135 92.10241601 -58.12333185 89.38000969 -71.53125 77.87890625 C-80.97103459 68.91708544 -87.67242516 56.78360973 -88.421875 43.625 C-88.61029235 27.56242059 -85.14686123 13.96988831 -73.9296875 1.7734375 C-52.37971354 -18.15290829 -22.50317 -18.34325301 0 0 Z " fill="#7C3AED" transform="translate(204.21875,31.80859375)"/>
<path d="M0 0 C4.07450845 1.30966343 5.82644163 2.82236907 8.5 6.125 C9.54491285 9.25973855 9.37041373 11.47408512 9.12866211 14.72167969 C8.58646945 21.3999423 8.58646945 21.3999423 11.18359375 27.3125 C12.72746669 28.38277587 14.31348532 29.39400071 15.9296875 30.3515625 C19.12874011 32.55881156 20.85024773 35.06651503 23.0625 38.25 C26.77853193 43.39871894 29.85500061 46.35033928 35.5 49.125 C50.9556962 57.06170886 50.9556962 57.06170886 54.5 62.125 C55.54797585 66.6941747 54.99878644 70.74291711 52.9375 74.9375 C49.69077416 79.84164532 44.83609715 81.90676248 39.375 83.5 C31.63335887 85.01640393 23.67313294 83.04876403 16.5 80.125 C13.61209427 80.125 12.10419528 80.5320232 10.02734375 82.5703125 C9.02912337 83.66809962 8.05965593 84.79292422 7.125 85.9453125 C5.5 87.125 5.5 87.125 3.28320312 86.90600586 C-0.04627495 85.97170758 -2.6601445 84.53779668 -5.65625 82.80859375 C-6.23983276 82.47384537 -6.82341553 82.13909698 -7.42468262 81.79420471 C-9.2869604 80.72347559 -11.14335618 79.64296221 -13 78.5625 C-14.21580146 77.86333311 -15.4319448 77.16476038 -16.6484375 76.46679688 C-24.69279932 71.83537862 -32.62053815 67.031531 -40.5 62.125 C-38.84140087 57.76050957 -36.62774547 54.08857921 -34 50.25 C-33.56075195 49.59797607 -33.12150391 48.94595215 -32.66894531 48.27416992 C-30.40504159 44.91497185 -28.11984428 41.57072576 -25.828125 38.23046875 C-19.62402599 29.13632663 -14.30436786 20.0500945 -10.4375 9.6875 C-8.29596034 4.24588283 -6.34640568 0.22665735 0 0 Z " fill="#9A48FF" transform="translate(457.5,315.875)"/>
</svg>
                                `);


                                export const DriverLocationIcon =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#3E358F" d="M135.2 117.4L109.1 192l293.8 0-26.1-74.6C372.3 104.6 360.2 96 346.6 96L165.4 96c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32l181.2 0c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2l0 144 0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48L96 400l0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48L0 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>
                                `);
